
/** 空白字符、中英文逗号分隔；分号保留为内容。由调用方组装接口参数。 */
export const parseBatchSearch = (value: string): { keyword: string; strs?: string[] } => {
  const values = value.trim().split(/[\s,，]+/).filter(Boolean);
  if (values.length > 1) {
    return { keyword: "", strs: Array.from(new Set(values)) };
  }
  return { keyword: value.trim() };
};
